export default {
    GET_IMPORTERS: "[zina_flow][importers] get all importers",
    GET_IMPORTERS_SUCCESS: "[zina_flow][importers] get all importers SUCCESS",
    GET_IMPORTERS_FAIL: "[zina_flow][importers] get all importers FAIL",
    UPDATE_PAGINATION: "[zina_flow][importers] update importers pagination",
    CHANGE_PAGE: "[zina_flow][importers] change importers page",
    FILTER_LIST: "[zina_flow][importers] change importers filters"
};
